// Not ported (dead in the Angular app): getNotes, saveNotes
import { api } from '@/core/http/apiClient';
import type {
  ReportHeadingRow,
  ReportOptionLists,
  ReportSettingsView,
  RevisedAccountsView,
  SaveReplacementPayload,
  SaveReportHeadingsPayload,
  SaveShareCapitalPayload,
  SaveSupplementaryPayload,
  ShareCapitalRow,
  ShareCapitalView,
} from '@/core/models/report-options.models';

let optionsRequest: Promise<ReportOptionLists> | null = null;

export const reportOptionsService = {
  /** Pick lists rarely change, so one request is shared for the session (a failed request is retried next time). */
  getOptions: () => {
    if (!optionsRequest) {
      const request = api.get<ReportOptionLists>('ReportOptions/getOptions');
      optionsRequest = request;
      request.catch(() => {
        if (optionsRequest === request) optionsRequest = null;
      });
    }
    return optionsRequest;
  },

  // ---- Customise headings ----

  getHeadings: (clientId: string) => api.get<ReportHeadingRow[]>(`ReportOptions/getHeadings/${clientId}`),

  saveHeadings: (payload: SaveReportHeadingsPayload) =>
    api.post<ReportHeadingRow[]>('ReportOptions/saveHeadings', payload),

  // ---- Report settings ----

  getReportSettings: (clientId: string) => api.get<ReportSettingsView>(`ReportOptions/getReportSettings/${clientId}`),

  saveReportSettings: (payload: ReportSettingsView) =>
    api.post<ReportSettingsView>('ReportOptions/saveReportSettings', payload),

  // ---- Revised accounts ----

  getRevisedAccounts: (clientId: string, accountingPeriodId: string) =>
    api.get<RevisedAccountsView>(`ReportOptions/getRevisedAccounts/${clientId}/${accountingPeriodId}`),

  saveRevisionType: (clientId: string, accountingPeriodId: string, revisionType: number) =>
    api.post<RevisedAccountsView>('ReportOptions/saveRevisionType', { clientId, accountingPeriodId, revisionType }),

  saveReplacement: (payload: SaveReplacementPayload) =>
    api.post<RevisedAccountsView>('ReportOptions/saveReplacement', payload),

  saveSupplementary: (payload: SaveSupplementaryPayload) =>
    api.post<RevisedAccountsView>('ReportOptions/saveSupplementary', payload),

  // ---- Share capital ----

  getShareCapital: (clientId: string) => api.get<ShareCapitalView>(`ReportOptions/getShareCapital/${clientId}`),

  saveShareCapital: (payload: SaveShareCapitalPayload) =>
    api.post<ShareCapitalRow>('ReportOptions/saveShareCapital', payload),

  deleteShareCapital: (id: string) => api.post<boolean>(`ReportOptions/deleteShareCapital/${id}`, {}),

  setDisplayAuthorisedShares: (clientId: string, value: boolean) =>
    api.post<boolean>(`ReportOptions/setDisplayAuthorisedShares/${clientId}`, { value }),
};
